import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const PacifierOutline = createIcon({
  displayName: 'PacifierOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <rect width="24" height="24"></rect>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M13.554 15.541l-.41.149 -2.61145e-07 9.48274e-08c-1.37778.500301-2.92062.157576-3.957-.879v0l-2.37061e-07-2.37096e-07c-1.03635-1.0365-1.37904-2.57921-.879-3.957l.149-.409 -2.378-2.378 -8.23893e-09-8.2233e-09c-.703611-.702276-.704693-1.84197-.00241672-2.54558 .000804813-.000806343.00161039-.00161192.00241673-.00241673v0l-6.94018e-09 6.95337e-09c.702276-.703611 1.84197-.704693 2.54558-.00241675 .000806343.000804813.00161192.00161039.00241673.00241673l9.853 9.852 -6.01199e-09-5.99587e-09c.703887.701999.705417 1.8417.00341789 2.54558 -.00113776.00114082-.00227706.00228012-.00341788.00341788v0l4.73594e-08-4.74494e-08c-.702276.703611-1.84197.704693-2.54558.00241683 -.000806343-.000804813-.00161192-.00161039-.00241674-.00241673Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15.411 12.3l4.251-3.224 5.92336e-08-4.48722e-08c1.48885-1.12787 1.78148-3.24915.653608-4.738 -1.12787-1.48885-3.24915-1.78148-4.738-.653608 -.246756.186929-.466679.406852-.653608.653608l-3.224 4.253"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M4.428 12.678l2.98265e-07-2.95042e-07c-1.91412 1.89344-1.93088 4.98007-.0374422 6.89419 1.89344 1.91412 4.98007 1.93088 6.89419.0374422 1.0081-.997214 1.53206-2.38394 1.43525-3.79863"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M8.188 11.28l3.32045e-07 2.35308e-08c-1.39681-.0989868-2.76807.411589-3.76 1.4"
        ></path>
      </g>
    </>
  ),
})

const PacifierTwoTone = createIcon({
  displayName: 'PacifierTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" fill="none" color="twoToneStrokeColor">
        <Box
          as="path"
          fill="twoToneFillColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15.411 12.3l4.251-3.224 5.92336e-08-4.48722e-08c1.48885-1.12787 1.78148-3.24915.653608-4.738 -1.12787-1.48885-3.24915-1.78148-4.738-.653608 -.246756.186929-.466679.406852-.653608.653608l-3.224 4.253"
        ></Box>
        <Box
          as="path"
          stroke="twoToneFillColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M4.428 12.678l2.98265e-07-2.95042e-07c-1.91412 1.89344-1.93088 4.98007-.0374422 6.89419 1.89344 1.91412 4.98007 1.93088 6.89419.0374422 1.0081-.997214 1.53206-2.38394 1.43525-3.79863"
        ></Box>
        <Box
          as="path"
          stroke="twoToneFillColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M8.188 11.28l3.32045e-07 2.35308e-08c-1.39681-.0989868-2.76807.411589-3.76 1.4"
        ></Box>
        <rect width="24" height="24"></rect>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M13.554 15.541l-.41.149 -2.61145e-07 9.48274e-08c-1.37778.500301-2.92062.157576-3.957-.879v0l-2.37061e-07-2.37096e-07c-1.03635-1.0365-1.37904-2.57921-.879-3.957l.149-.409 -2.378-2.378 -8.23893e-09-8.2233e-09c-.703611-.702276-.704693-1.84197-.00241672-2.54558 .000804813-.000806343.00161039-.00161192.00241673-.00241673v0l-6.94018e-09 6.95337e-09c.702276-.703611 1.84197-.704693 2.54558-.00241675 .000806343.000804813.00161192.00161039.00241673.00241673l9.853 9.852 -6.01199e-09-5.99587e-09c.703887.701999.705417 1.8417.00341789 2.54558 -.00113776.00114082-.00227706.00228012-.00341788.00341788v0l4.73594e-08-4.74494e-08c-.702276.703611-1.84197.704693-2.54558.00241683 -.000806343-.000804813-.00161192-.00161039-.00241674-.00241673Z"
        ></path>
      </Box>
    </>
  ),
})

const Pacifier: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
  case 'twoTone':
    return <CustomIcon as={PacifierTwoTone} {...props} />
  default:
    return <CustomIcon as={PacifierOutline} {...props} />
  }
}

export default memo(Pacifier)
